// M004-F0746 (design section 7): re-read the open envelope while any receipt is queued or reading - first after 2 s, backing off to 10 s,
// starting again at 2 s whenever a read makes progress, and STOPPING the moment none is reading. No push channel exists and none is added.
import { useEffect, useRef, useState } from 'react';
import { pollDelay } from './ocrModel';

export default function useOcrPolling({ active, signature, reload }) {
  const attempt = useRef(0);
  const last = useRef(signature);
  const reloadRef = useRef(reload);
  reloadRef.current = reload;
  const [tick, setTick] = useState(0);
  useEffect(() => {
    if (last.current !== signature) { last.current = signature; attempt.current = 0; }
    if (!active) { attempt.current = 0; return undefined; }
    const timer = setTimeout(async () => {
      const n = attempt.current;
      attempt.current = n + 1;
      try { await reloadRef.current(); } finally { setTick((value) => value + 1); }
    }, pollDelay(attempt.current));
    return () => clearTimeout(timer);
  }, [active, signature, tick]);
}
